import {
    CLOSE_CREATE_MEETING_OVERLAY,
    HIDE_MANAGE_MEETING_POPOVER,
    OPEN_CREATE_MEETING_OVERLAY,
    SHOW_MANAGE_MEETING_POPOVER,
    SHOW_MY_SCHEDULE_TAB,
    TOGGLE_SCHEDULE_MEETING_TOAST,
    UNREAD_MEETING_COUNT,
    UPDATE_ATTENDEE_LIST,
} from 'store/actions/ScheduleMeeting';

const initialState = {
    showOverlay: false,
    showPopover: false,
    attendeeList: {},
    toastMsg: '',
    unreadMeetingCount: 0,
    showMyScheduleTab: false,
};

function scheduleMeeting(state = initialState, action) {
    const { payload, type } = action;
    switch (type) {
        case OPEN_CREATE_MEETING_OVERLAY:
            return { ...state, showOverlay: true };
        case CLOSE_CREATE_MEETING_OVERLAY:
            return { ...state, showOverlay: false };
        case SHOW_MANAGE_MEETING_POPOVER:
            return { ...state, showPopover: true };
        case HIDE_MANAGE_MEETING_POPOVER:
            return { ...state, showPopover: false };
        case UPDATE_ATTENDEE_LIST:
            return { ...state, attendeeList: payload };
        case TOGGLE_SCHEDULE_MEETING_TOAST:
            return { ...state, toastMsg: payload };
        case UNREAD_MEETING_COUNT:
            return { ...state, unreadMeetingCount: payload };
        case SHOW_MY_SCHEDULE_TAB:
            return { ...state, showMyScheduleTab: payload };
        default:
            return state;
    }
}

export default scheduleMeeting;
